export enum InviteFormFields {
  peoPayrollProviders = 'peoPayrollProviders',
}

export enum InviteFormPeoPayrollProviderFields {
  email = 'email',
  isRevenueShareEnabled = 'isRevenueShareEnabled',
}

export type PeoPayrollProvider = {
  [InviteFormPeoPayrollProviderFields.email]: string;
  [InviteFormPeoPayrollProviderFields.isRevenueShareEnabled]: boolean;
};

export type InviteFormValues = {
  [InviteFormFields.peoPayrollProviders]: PeoPayrollProvider[];
};
